// extracted by mini-css-extract-plugin
export default {"container":"QuestionChoiceTagging_container__Y-ucC","selectorsContainer":"QuestionChoiceTagging_selectorsContainer__8DDmH","answer":"QuestionChoiceTagging_answer__d4bXo"};